import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import axios from 'axios';
import { identifyUser, track } from '../utils/analytics';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');
        
        if (!sessionId) {
          navigate('/login');
          return;
        }

        const response = await axios.post(`${API}/auth/google`, { session_id: sessionId });
        const { access_token, user, is_new_user } = response.data;
        
        // Use existing auth login (stores token + user in localStorage)
        authLogin(access_token, user);

        // Analytics: identify on every Google auth, track signup_completed only
        // for first-time accounts (backend tells us via is_new_user).
        if (user?.id) {
          identifyUser(user.id, { email: user.email, username: user.username });
        }
        if (is_new_user) {
          track('signup_completed', { method: 'google' });
        }
        
        // Clear hash and redirect
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/select-gender');
      } catch (error) {
        console.error('Google auth error:', error);
        navigate('/login');
      }
    };

    processGoogleAuth();
  }, []);

  return (
    <div className="min-h-screen bg-velvet-bg flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="animate-spin text-purple-light mx-auto mb-4" size={40} />
        <p className="text-velvet_text-secondary">Connexion en cours...</p>
      </div>
    </div>
  );
}
